import { render } from "./AppAlertCardRich.vue?vue&type=template&id=30c52508&scoped=true&lang=pug"
import script from "./AppAlertCardRich.vue?vue&type=script&lang=js"
export * from "./AppAlertCardRich.vue?vue&type=script&lang=js"

import "./AppAlertCardRich.vue?vue&type=style&index=0&id=30c52508&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c52508"]])

export default __exports__